import React from 'react'
import { submitReportProgress } from '@/enums/submitReportProgress'
import context from '@/context'
import { BackgroundJobCard } from '@/report-app/pages/reporting/submissions/submit/backgroundJobCard'

function ValidateSubmissionCard ({ submitProgress, reportInstanceGroupId, backgroundJobMetadata, onJobStarted }) {
  return <BackgroundJobCard dataCy='validateSubmissionCard'
    backgroundJobMetadata={backgroundJobMetadata}
    onJobStarted={onJobStarted}
    reportInstanceGroupId={reportInstanceGroupId}
    submitProgress={submitProgress}
    headerText='Reporting.ValidatingSubmission'
    beforeStartText='Reporting.ValidateSubmission'
    bgJobSubmitProgress={submitReportProgress.enum.Validated}
    startCardSubmitProgress={submitReportProgress.enum.Recalculated}
    bgJobEndpoint={context.api.reportSubmissionGroupService.validateSubmission} />
}

export { ValidateSubmissionCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/validateSubmissionCard.js